import { JSX } from 'react'

import { IconProps } from '../../icon'

const Bookmark: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M29.7484 8H19.4417C15.8859 8 13 10.8859 13 14.4417V36.9963C13 38.1128 13.6012 39.1263 14.5804 39.6417C15.5595 40.1742 16.7448 40.1055 17.6724 39.487L24.3546 35.038C24.492 34.9349 24.681 34.9349 24.8356 35.038L31.5178 39.487C32.0159 39.8306 32.6 39.9852 33.184 39.9852C33.665 39.9852 34.1631 39.865 34.6098 39.6245C35.5889 39.1091 36.1901 38.0785 36.1901 36.9791V14.4417C36.1901 10.8859 33.3043 8 29.7484 8ZM33.6135 36.9963C33.6135 37.2196 33.476 37.3226 33.3901 37.3742C33.3043 37.4257 33.1325 37.4772 32.9435 37.357L26.2613 32.9079C25.2478 32.2208 23.9423 32.2208 22.9288 32.9079L16.2466 37.357C16.0577 37.4772 15.8859 37.4257 15.8 37.3742C15.7141 37.3226 15.5767 37.2196 15.5767 36.9963V14.4417C15.5767 12.3116 17.3116 10.5767 19.4417 10.5767H29.7484C31.8785 10.5767 33.6135 12.3116 33.6135 14.4417V36.9963Z'
      fill='black'
    />
  </svg>
)

export default Bookmark
